import { RequirementExpirationStrategy } from "@wingspanhq/payments/dist/interfaces/requirement";

export const getExpirationLabel = (
  strategy?: RequirementExpirationStrategy,
  days?: number
): string => {
  if (!strategy || strategy === RequirementExpirationStrategy.None) {
    return "No expiration";
  }

  switch (strategy) {
    case RequirementExpirationStrategy.DaysAfterComplete:
      return `${days ?? 0} days after completion`;
    case RequirementExpirationStrategy.DaysAfterYearStart:
      return `${days ?? 0} days after year start`;
    case RequirementExpirationStrategy.DaysBeforeYearEnd:
      return `${days ?? 0} days before year end`;
    default:
      return "Custom expiration";
  }
};
